import { MainArea as e, ZoomContainer as t } from "./styles.mjs";
import { GalleryMainImage as n } from "./components/GalleryMainImage.mjs";
import { GalleryNavButton as r } from "./components/GalleryNavButton.mjs";
import { GalleryOverlay as i } from "./components/GalleryOverlay.mjs";
import { GalleryThumbnailStrip as a } from "./components/GalleryThumbnailStrip.mjs";
import { GalleryTopBar as o } from "./components/GalleryTopBar.mjs";
import { useGalleryNavigation as s } from "./hooks/useGalleryNavigation.mjs";
import { useGalleryKeyboard as c } from "./hooks/useGalleryKeyboard.mjs";
import { useGallerySwipe as l } from "./hooks/useGallerySwipe.mjs";
import { useGalleryZoom as u } from "./hooks/useGalleryZoom.mjs";
import "react";
import { useTranslation as d } from "@maat/store-i18n";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/FullscreenGallery/FullscreenGallery.tsx
var m = ({ images: m, open: h, onClose: g, initialIndex: _ = 0, altPrefix: v, labels: y, actions: b }) => {
	let { t: x } = d("ds"), S = s(m.length, _, h), C = c(S), w = l(S), { zoom: T, zoomHandlers: E } = u(S.currentIndex), D = v ?? x("ds:gallery.imageAlt");
	if (!m.length) return null;
	let O = T.isZoomed ? {
		onTouchStart: E.onTouchStart,
		onTouchMove: E.onTouchMove,
		onTouchEnd: E.onTouchEnd
	} : {
		onTouchStart: (e) => {
			e.touches.length >= 2 ? E.onTouchStart(e) : w.onTouchStart(e);
		},
		onTouchMove: (e) => {
			e.touches.length >= 2 && E.onTouchMove(e);
		},
		onTouchEnd: (e) => {
			T.scale > 1.05 ? E.onTouchEnd(e) : w.onTouchEnd(e);
		}
	};
	return /* @__PURE__ */ p(i, {
		open: h,
		onClose: g,
		title: y?.[S.currentIndex] ?? x("ds:gallery.title"),
		onKeyDown: C,
		children: [
			/* @__PURE__ */ f(o, {
				currentIndex: S.currentIndex,
				totalImages: S.totalImages,
				onClose: g,
				label: y?.[S.currentIndex],
				actions: b
			}),
			/* @__PURE__ */ p(e, {
				...O,
				children: [
					/* @__PURE__ */ f(r, {
						direction: "prev",
						disabled: !S.canPrev,
						onClick: S.goPrev
					}),
					/* @__PURE__ */ f(t, {
						$scale: T.scale,
						$tx: T.translateX,
						$ty: T.translateY,
						$isZoomed: T.isZoomed,
						onClick: E.onClick,
						onWheel: E.onWheel,
						onMouseDown: E.onMouseDown,
						onMouseMove: E.onMouseMove,
						onMouseUp: E.onMouseUp,
						onMouseLeave: E.onMouseLeave,
						children: /* @__PURE__ */ f(n, {
							src: m[S.currentIndex],
							alt: `${D} ${S.currentIndex + 1}`
						})
					}),
					/* @__PURE__ */ f(r, {
						direction: "next",
						disabled: !S.canNext,
						onClick: S.goNext
					})
				]
			}),
			/* @__PURE__ */ f(a, {
				images: m,
				currentIndex: S.currentIndex,
				onSelect: S.goTo,
				altPrefix: D
			})
		]
	});
};
//#endregion
export { m as FullscreenGallery };
